<template>
  <div :class="`keyboard-${theme}`">
    <b-row class="text-center">
      <b-col cols="4" class="noselect kbdigit m-auto px-1" v-for="(Char, Index) in 9" :key="Index">
        <button class="char" @click.prevent="KeyboardClick(Char)">{{ Char }}</button>
      </b-col>
      <b-col cols="4" class="noselect m-auto px-1">
        <button class="char" @click.prevent="KeyboardClick('del')">
          <i class="material-icons">backspace</i>
        </button>
      </b-col>
      <b-col cols="4" class="noselect kbdigit m-auto px-1">
        <button class="char" @click.prevent="KeyboardClick(0)">0</button>
      </b-col>
      <b-col cols="4" class="noselect m-auto px-1">
        <button class="char" type="submit">Enter</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

function GetValue(El) {
  return El.value;
}

function SetValue(El, Val) {
  El.value = Val;
}

export default {
  props: {
    type: {
      type: String,
      default: "All"
    },
    theme: {
      type: String,
      default: "Dark"
    }
  },
  computed: {
    ...mapState(["FocusedData"])
  },
  methods: {
    KeyboardClick(Char) {
      if (this.FocusedData === null) return false;

      const El = document.getElementById(this.FocusedData.El);

      let Val = "";

      if (Char === "del") Val = GetValue(El).substr(0, GetValue(El).length - 1);
      else Val = GetValue(El) + Char;

      SetValue(El, Val);

      this.$store.dispatch("SetData", {
        Key: this.FocusedData.Data,
        Value: Val
      });

      this.$forceUpdate();
    },
    FormSubmit() {
      this.$store.dispatch("SendForm", this.FocusedData.Form);
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Segment14";
  src: url("../assets/fonts/Segment14.otf") format("opentype");
}
.kbdigit {
  font-family: "Segment14", sans-serif;
  font-weight: 300;
  display: inline-block;
}
.kbdigit.success {
  background: #ebffed;
  color: #4caf50;
}
.kbdigit.danger {
  background: #ffebeb;
  color: #af4c4c;
}
.kbdigit.info {
  background: #ebf4ff;
  color: #4c7aaf;
}
.char {
  width: 100%;
  border: 1px solid #555;
  background: #2e2e2e;
  padding: 24px 0;
  display: inline-block;
  line-height: 36px;
  margin: 4px 0;
  color: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 24px;
  box-sizing: border-box;
}
.char:active {
  background: #a2671b;
}
.keyboard-Light .char {
  background: #fcfcfc;
  color: #2e2e2e;
  border: 1px solid #cecece;
}
.keyboard-Light .char:active {
  color: #fff;
  background: #00509b;
}
</style>